
import React from 'react';
import { Modal, Typography, Divider, Row, Col, Space, Button, Popconfirm, message } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { CashFlow } from '../../types';

const { Title, Text } = Typography;

interface CashFlowDetailsProps {
  visible: boolean;
  onClose: () => void;
  cashFlow: CashFlow | null;
  onEdit: (cashFlow: CashFlow) => void;
  onDelete: (cashFlowId: string) => void;
}

const CashFlowDetails: React.FC<CashFlowDetailsProps> = ({
  visible,
  onClose,
  cashFlow,
  onEdit,
  onDelete,
}) => {
  if (!cashFlow) return null;

  const handleDelete = () => {
    onDelete(cashFlow.id);
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={500}
      bodyStyle={{ padding: '24px', maxHeight: '80vh', overflowY: 'auto' }}
      // Removed custom positioning to maintain default modal behavior
      closable
      maskClosable
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        {/* Header with Actions */}
        <Space style={{ width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
          <Title level={4}>Cash Flow Details</Title>
          <Space>
            <Button
              type="primary"
              icon={<EditOutlined />}
              onClick={() => onEdit(cashFlow)}
            >
              Edit
            </Button>
            <Popconfirm
              title="Are you sure you want to delete this cash flow?"
              onConfirm={handleDelete}
              okText="Yes"
              cancelText="No"
            >
              <Button type="primary" danger icon={<DeleteOutlined />}>
                Delete
              </Button>
            </Popconfirm>
          </Space>
        </Space>

        <Divider />

        {/* CashFlow Information */}
        <Title level={5}>CashFlow Information</Title>
        <Row gutter={16}>
          <Col span={12}>
            <Text strong>Name:</Text>
            <br />
            <Text>{cashFlow.name}</Text>
          </Col>
          <Col span={12}>
            <Text strong>Description:</Text>
            <br />
            <Text>{cashFlow.description}</Text>
          </Col>
        </Row>

        <Divider />

        {/* CashFlow Type and Amount */}
        <Title level={5}>CashFlow Details</Title>
        <Row gutter={16}>
          <Col span={12}>
            <Text strong>Type:</Text>
            <br />
            <Text>{cashFlow.type}</Text>
          </Col>
          <Col span={12}>
            <Text strong>Payment Amount:</Text>
            <br />
            <Text>${cashFlow.amount.toLocaleString()}</Text>
          </Col>
        </Row>
      </Space>
    </Modal>
  );
};

export default CashFlowDetails;
